import { AdUnit, AdUnitClasses } from 'googlead/components/AdUnit';
import { GPTAds } from 'googlead/GPTAds';
import { AdPositions } from 'googlead/types';
import React from 'react';
import styles from './adunit.module.scss';

export const SidebarAd = () => (
  <div className={styles.sticky}>
    <AdUnit
      generator={GPTAds[AdPositions.Skyscraper]}
      className={AdUnitClasses.sky}
      desktop
      mobile
      recreateOnTablet
    />
  </div>
);
